import { PROTOCOL_VERSION } from '../lib/constants';

export const FRAME_HEADER_BYTES = 16;

export interface DecodedFrame {
  fileIndex: number;
  blockIndex: number;
  frameIndex: number;
  payload: Uint8Array;
}

export function encodeFrame(fileIndex: number, blockIndex: number, frameIndex: number, payload: Uint8Array): ArrayBuffer {
  const output = new Uint8Array(FRAME_HEADER_BYTES + payload.byteLength);
  const view = new DataView(output.buffer);
  view.setUint8(0, PROTOCOL_VERSION);
  view.setUint8(1, 0);
  view.setUint16(2, frameIndex);
  view.setUint32(4, fileIndex);
  view.setUint32(8, blockIndex);
  view.setUint32(12, payload.byteLength);
  output.set(payload, FRAME_HEADER_BYTES);
  return output.buffer;
}

export function decodeFrame(buffer: ArrayBuffer): DecodedFrame {
  if (buffer.byteLength < FRAME_HEADER_BYTES) throw new Error('Data frame is too short.');
  const view = new DataView(buffer);
  if (view.getUint8(0) !== PROTOCOL_VERSION) throw new Error('Incompatible data-frame protocol.');
  const payloadLength = view.getUint32(12);
  if (payloadLength !== buffer.byteLength - FRAME_HEADER_BYTES) throw new Error('Invalid data-frame length.');
  return {
    frameIndex: view.getUint16(2),
    fileIndex: view.getUint32(4),
    blockIndex: view.getUint32(8),
    payload: new Uint8Array(buffer, FRAME_HEADER_BYTES, payloadLength),
  };
}
